export type JSONwithRefsType = {
	[key: string]: Array<JSONwithRefsType> | JSONwithRefsType | unknown;
	$ref?: string;
};

export const resolveJSONrefs = async (json: JSONwithRefsType): Promise<object> => {
	const resolveReference = async (ref: string): Promise<unknown> => {
		const getInternalReference = () => {
			const path = ref.split('/').slice(1);
			let result = json;

			for (const segment of path) {
				if (typeof result !== 'object' || result === null) throw new Error('Invalid reference path');

				result = result[segment] as JSONwithRefsType;
			}

			return result;
		};

		if (ref.startsWith('#')) return getInternalReference();

		throw new Error('Unhandled JSON "$ref" type.');
	};

	const dereference = async (obj: JSONwithRefsType): Promise<JSONwithRefsType> => {
		if (typeof obj !== 'object' || obj === null) return obj as JSONwithRefsType;

		if (Array.isArray(obj)) {
			for (let i = 0; i < obj.length; i++) {
				obj[i] = await dereference(obj[i] as JSONwithRefsType);
			}
		} else {
			for (const key in obj) {
				if (key === '$ref') {
					const ref = obj[key] as string;

					const dereferencedValue = await resolveReference(ref);

					const dereferencedObj = dereferencedValue as JSONwithRefsType;

					return await dereference(dereferencedObj);
				} else {
					obj[key] = await dereference(obj[key] as JSONwithRefsType);
				}
			}
		}

		return obj;
	};

	const result = await dereference(json);

	return result;
};
